<div class="filtro">
  <div class="filter-div">
    <form [formGroup]="form" (ngSubmit)="filtrar()" class="h-100 div-expand">
      <div class="fields-expand">
        <div class="col-md-12 section-field">
          <label class="col-sm-12 pb-1">Orgãos:</label>
          <mat-form-field class="select">
            <mat-select formControlName="agency_id" multiple name="type_list">
              <mat-option *ngFor="let item of filters.agencies" [value]="item.id"> {{item.label}}</mat-option>
            </mat-select>
          </mat-form-field>
          <app-field-message [field]="fieldMessageRequired('agency_id')" [erros]="fieldErros('agency_id')"></app-field-message>
        </div>
        <div class="col-md-12 section-field">
          <label class="col-sm-12 pb-1">Indicador - Realizado:</label>
          <mat-form-field class="select">
            <mat-select formControlName="pf_ind_current_table_status" multiple name="type_list">
              <mat-option *ngFor="let item of filters.pfIndCurrentTable" [value]="item.id"> {{item.label}}</mat-option>
            </mat-select>
          </mat-form-field>
          <app-field-message [field]="fieldMessageRequired('pf_ind_current_table_status')" [erros]="fieldErros('pf_ind_current_table_status')"></app-field-message>
        </div>
        <div class="col-md-12 section-field">
          <label class="col-sm-12 pb-1">Indicador - Projeção:</label>
          <mat-form-field class="select">
            <mat-select formControlName="pf_ind_analysis_stat_id" multiple name="type_list">
              <mat-option *ngFor="let item of filters.pfIndAnalysisStat" [value]="item.id"> {{item.label}}</mat-option>
            </mat-select>
          </mat-form-field>
          <app-field-message [field]="fieldMessageRequired('pf_ind_analysis_stat_id')" [erros]="fieldErros('pf_ind_analysis_stat_id')"></app-field-message>
        </div>
        <div class="col-md-12 section-field">
          <label class="col-sm-12 pb-1">Exibir:</label>
          <mat-form-field class="select">
            <mat-select formControlName="enabled" multiple name="type_list">
              <mat-option *ngFor="let item of filters.enabledOptions" [value]="item.id"> {{item.label}}</mat-option>
            </mat-select>
          </mat-form-field>
          <app-field-message [field]="fieldMessageRequired('enabled')" [erros]="fieldErros('enabled')"></app-field-message>
        </div>
      </div>
      <div class="hr-line-dashed"></div>
      <div class="form-group row d-flex justify-content-end">
        <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
          <button class="btn btn-primary m-r-xs" type="submit">Filtrar</button>
          <button class="btn btn-white" type="button" (click)="onCloseFilter()">Cancelar</button>
        </div>
      </div>
    </form>
  </div>
</div>
